<template>
  <div class="list-box">
    <ul class="list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="征收项目"
          prop="zsxmmc"
          :formatter="$tab_TextFormat"
          width="140"
        />
        <el-table-column
          prop="zspmmc"
          label="征收品目"
          :formatter="$tab_TextFormat"
          width="140"
        />
        <el-table-column
          prop="dzsphm"
          label="电子税票号码"
          :formatter="$tab_TextFormat"
          min-width="120"
        />
        <el-table-column
          prop="sjtje"
          label="实缴(退)金额"
          :formatter="$tab_PriceFormat"
          min-width="100"
          align="right"
        >
        </el-table-column>
        <el-table-column
          prop="rkrq"
          label="入(退)库日期"
          min-width="100"
          :formatter="$tab_TextFormat"
          align="center"
        >
          <template #default="{ row }">
            <text>{{ $dayjs.unix(row.rkrq / 1000).format("YYYY-MM-DD") }}</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="skssjgmc"
          label="税款所属税务机关"
          :formatter="$tab_TextFormat"
          min-width="240"
        />
        <el-table-column
          prop="zgswsmc"
          label="主管税务所(科)分局"
          :formatter="$tab_TextFormat"
          min-width="240"
        />
        <el-table-column
          prop="sftf"
          label="已退付"
          :formatter="$tab_ShowToolTip"
          width="100"
          align="center"
        >
          <template #default="{ row }">
            <text :style="{ color: row.sftf ? '#1e90ff' : '#f00' }">{{
              row.sftf ? "是" : "否"
            }}</text>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { ptscommission_gethdqc } from "@/http/ptscommission";
import {
  data_taxbureau_select,
  data_withholdingagent_select,
} from "@/http/data";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadWithholdingAgent();
      onLoadTaxBureau();

      state.params.pts_commission_id = props.id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      ptscommission_gethdqc(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //加载扣缴义务人
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200)
          state.withholding_agent_data = res.data.data?.list;
      });
    };

    //加载税局
    const onLoadTaxBureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadWithholdingAgent,
      onRowClick,
      onLoadTaxBureau,
    };
  },
};
</script>
<style scoped></style>
